module.exports = __webpack_public_path__ + "img/SUV_Front_Side_Right_Transparent.8089765b.svg";